import { createClient } from '@supabase/supabase-js';
import { readPublicEnv } from '@/lib/runtime-env';

const SUPABASE_URL = readPublicEnv('PUBLIC_SUPABASE_URL');
const SUPABASE_PUBLISHABLE_KEY = readPublicEnv('PUBLIC_SUPABASE_PUBLISHABLE_KEY');

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error('Missing supabase info');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    // PKCE flow (supabase.com/docs/guides/auth/sessions/pkce-flow): detects a
    // session in the URL, e.g. a password-reset link.
    detectSessionInUrl: true,
    autoRefreshToken: true,
  },
});
